import React from "react";
import { useIntl } from "react-intl";
import { PeekBox, PeekStack, PeekTooltip, PeekTypography, useTheme } from "@piiqtechnologies/ui-components";
import { formatScoreValue } from "@utils/utils";
import { logPosition } from "../ranking-widget";
import { assignCompetitorColor } from "./colors";
import { isAbsoluteZero } from "./constants";
import messages from "./messages.i18n";
export const TrackedCompetitorsMarkers = ({ min, max, targetSubject, competitors, }) => {
    const intl = useIntl();
    const theme = useTheme();
    const targetPct = logPosition(targetSubject.appearanceRate, min, max);
    // Colors are assigned by position in the full list so chart dots stay in sync with the
    // list rows, then absolute zeros are dropped from the chart.
    const dots = competitors
        .map((c, i) => ({
        competitor: c,
        pct: logPosition(c.appearanceRate, min, max),
        color: assignCompetitorColor(i, theme.palette.graphColors),
    }))
        .filter(({ competitor }) => !isAbsoluteZero(competitor));
    const withOffset = dots.map((d, i) => {
        const sameScoreCount = dots
            .slice(0, i)
            .filter((o) => o.competitor.appearanceRate === d.competitor.appearanceRate).length;
        return Object.assign(Object.assign({}, d), { offsetY: sameScoreCount * -10 });
    });
    return (React.createElement(React.Fragment, null,
        withOffset.map(({ competitor, pct, color, offsetY }) => (React.createElement(PeekTooltip, { key: competitor.subjectId, title: React.createElement(PeekStack, null,
                React.createElement(PeekTypography, { variant: "body2", fontWeight: "fontWeightBold" }, competitor.subjectName),
                React.createElement(PeekTypography, { variant: "body2" }, intl.formatMessage(messages.dotTooltipScore, { score: formatScoreValue(competitor.appearanceRate) }))), placement: "top" },
            React.createElement(PeekBox, { "aria-label": competitor.subjectName, "data-testid": `competitor-dot-${competitor.subjectId}`, "data-position": pct, "data-offset": offsetY, sx: {
                    position: "absolute",
                    left: `${pct}%`,
                    top: "50%",
                    transform: `translate(-50%, calc(-50% + ${offsetY}px))`,
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    bgcolor: color,
                    border: 2,
                    borderColor: "background.paper",
                    zIndex: 1,
                    cursor: "default",
                } })))),
        React.createElement(PeekBox, { "data-testid": "target-marker", "data-position": targetPct, sx: {
                position: "absolute",
                left: `${targetPct}%`,
                top: "50%",
                transform: "translate(-50%, -50%)",
                width: 20,
                height: 20,
                borderRadius: "50%",
                border: 2,
                borderColor: "secondary.main",
                bgcolor: "background.paper",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 2,
            } },
            React.createElement(PeekBox, { sx: { width: 9, height: 9, borderRadius: "50%", bgcolor: "secondary.main" } }))));
};
export default TrackedCompetitorsMarkers;
